import {schema as Schema} from 'normalizr';

export const itemListEntity = new Schema.Entity('items', {}, {idAttribute: 'questionId'});
export const itemListSchema = new Schema.Array(itemListEntity);

export const questionEntity = new Schema.Entity('questions', {}, {idAttribute: 'id'});
export const itemQuestionsSchema = new Schema.Array(questionEntity);
